export default [
  {
    path: "/cadastrar",
    name: "register",
    component: () => import(/* webpackChunkName: "auth" */ "./Register.vue"),
    meta: { sidebar: false, topbar: false },
  },
];
